import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home.vue';
import Game from '../views/Game.vue';
import JoinUsSocial from '../views/JoinUsSocial.vue'
import SocialJobDetails from '../views/SocialJobDetails.vue'
import About from '../views/About.vue';
import Echics from "../views/Echics.vue";


Vue.use(VueRouter)

const routes = [
  {
    path: '*',
    redirect: '/'
  },
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/game',
    name: 'game',
    component: Game
  },
  // {
  //   path: '/join_campus',
  //   name: 'join_campus',
  //   component: JoinUsCampus
  // },
  // {
  //   path: '/join_campus_details',
  //   name: 'join_campus_details',
  //   component: CampusJobDetails,
  // },
  {
    path: '/join_social',
    name: 'join_social',
    component: JoinUsSocial
  },
  {
    path: '/join_social_details',
    name: 'join_social_details',
    component: SocialJobDetails,
  },
  {
    path: '/about',
    name: 'about',
    component: About
  },
  {
    path: '/ethics',
    name: 'ethics',
    component: Echics
  },
  // {
  //   path: '/privacy',
  //   name: 'privacy',
  //   component: Privacy
  // },
  // {
  //   path: '/terms',
  //   name: 'terms',
  //   component: Terms
  // },
]

const router = new VueRouter({
  mode: 'history',
  routes: routes
})

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
export default router



// WEBPACK FOOTER //
// ./src/router/index.js